import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';
export const useInputTooltip = ({ tooltip, tooltipTabIndex, tooltipIconColor, tooltipIconSize, }) => {
    const tooltipContent = typeof tooltip !== 'string' ? tooltip : undefined;
    const tooltipText = typeof tooltip === 'string' ? tooltip : undefined;
    const maybeTooltip = tooltip ? (_jsx(Tooltip, { content: tooltipContent, text: tooltipText, tabIndex: tooltipTabIndex, children: _jsx(Icon, { name: 'InfoOutline', color: tooltipIconColor, size: tooltipIconSize }) })) : null;
    return maybeTooltip;
};
